type Props = {
  className?: string;
  children: any[];
  onSubmit: any;
  size?: "sm" | "md" | "lg";
};

const ScenarioSide = (props: Props) => {
  const getSize = () => {
    switch (props?.size) {
      case "sm":
        return "md:tw-w-[310px] tw-w-full";
      case "lg":
        return "md:tw-w-[650px] tw-w-full";
      default:
        return "md:tw-w-[580px] tw-w-full";
    }
  };

  return (
    <form
      onSubmit={props.onSubmit}
      className={` tw-absolute tw-right-0 tw-bg-gray-50 tw-flex tw-h-full tw-flex-col tw-justify-between ${getSize()} ${
        props.className
      }`}
    >
      <div className="tw-p-2">{props.children?.[0]}</div>
      <div className="tw-h-full tw-overflow-y-auto tw-overflow-x-hidden">
        {props.children?.[1]}
      </div>
      <div className="tw-p-2">{props.children?.[2]}</div>
      {props.children?.[3]}
    </form>
  );
};

export default ScenarioSide;
